import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("POST");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("GET");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("htmltodataurl");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("add");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("get");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("delete");

import getCI from '@/utils/getCI';
import h2d from "@/utils/imgFunctions";
import db from "@/utils/indexeddbCache.js";
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',

  setup(__props) {
    const {
      proxy
    } = getCI();
    const request = proxy.$request;
    const params = {
      "aa": "a",
      "bb": "bbb"
    };

    function addData() {
      let data = {
        key: "aaa",
        value: 123
      };
      db.addCache(data);
    }

    async function getData() {
      let res = await db.getCacheByKey("aaa");
      console.log(res);
    }

    async function deleteData() {
      db.deleteCacheByKey("aaa");
    }

    function postTest() {
      request.post("/p", params);
    }

    function getTest() {
      request.get("/g", {
        params
      }).then(e => {
        console.log(e);
      });
    }

    async function dataurltest() {
      h2d.imgURL2DataURL("https://nimg.ws.126.net/?url=http%3A%2F%2Fdingyue.ws.126.net%2F2022%2F0330%2F3261d35fj00r9jljc001jc000hn00msc.jpg&thumbnail=660x2147483647&quality=80&type=jpg").then(e => {
        console.log(e);
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        onClick: postTest
      }, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        onClick: getTest
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        onClick: dataurltest
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        onClick: addData
      }, {
        default: _withCtx(() => [_hoisted_4]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        onClick: getData
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        onClick: deleteData
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      })])], 64);
    };
  }

});